import {
  TCreateAuctionFormValues,
  TUpdateAuctionFormValues,
} from "@components";
import { formatDateTimezoneToUTC } from "@utils";

export const getUTCDisclaimerSections = (
  values: TCreateAuctionFormValues | TUpdateAuctionFormValues
) => {
  const baseConditions = values.isOnline && values.timezone;
  const disclaimerSections: string[] = [];
  if (baseConditions && values.date && values.auctionTime) {
    disclaimerSections.push(
      `Start: ${formatDateTimezoneToUTC(
        `${values.date} ${values.auctionTime}`,
        values.timezone
      )}`
    );
  }
  if (baseConditions && values.auctionEndDate && values.auctionEndTime) {
    disclaimerSections.push(
      `End: ${formatDateTimezoneToUTC(
        `${values.auctionEndDate} ${values.auctionEndTime}`,
        values.timezone
      )}`
    );
  }
  return disclaimerSections;
};
